import { create } from "zustand";
import { useCheckoutStore } from "./checkoutStore";

type AuthState = {
  token: string | null
  user: any
  isAuthLoading: boolean

  setToken: (token: string | null) => void
  setUser: (user: any) => void
  setAuthLoading: (loading: boolean) => void

  logout: () => void
}

export const useAuthStore = create<AuthState>((set) => ({
  token: null,
  user: null,
  isAuthLoading: true,

  setToken: (token) => set({ token }),
  setUser: (user) => set({ user }),
  setAuthLoading: (loading) => set({ isAuthLoading: loading }),

  logout: () => {
    useCheckoutStore.getState().reset()
    localStorage.removeItem("auth_token")
    set({ token: null, user: null })
  },
}))